
export function hideDropdownMenu(){
    const drop1Ele = document.getElementById('ralb-gearicon');
        if(drop1Ele){
            drop1Ele.style.display = 'none';
            drop1Ele.classList.remove("open");
        }
}

export function toggleElementById(elementId,display){
    const element = document.getElementById(elementId);
    if(element){
        element.style.display =  display;
    }
}